import { useState } from "react";
import { HiMiniMagnifyingGlass } from "react-icons/hi2";
import { IoIosArrowRoundDown, IoIosArrowRoundUp } from "react-icons/io";

const Table1 = ({
  className,
  searchPlaceholder,
  searchValue,
  setSearchValue,
  additionalField,
  columns,
  data,
  totalRecords,
  limit,
  offset,
  setOffset,
  setLimit,
  sortField,
  sortOrder,
  isAllowAllList = true,
  handleSort,
}) => {
  const totalPages = limit ? Math.ceil(totalRecords / limit) : 1;
  const currentPage = limit ? Math.ceil(offset / limit) + 1 : 1;
  const baseIndex = offset;

  const handleLimitChange = (e) => {
    setLimit(Number(e.target.value));
    setOffset(0); // Reset to first page on limit change
  };

  const getSortIcon = (field) => {
    if (sortField === field) {
      return sortOrder === "asc" ? (
        // <icon iconName="arrow-up" className="text-primary" />
        <IoIosArrowRoundUp className="table-s-arr"/>
      ) : (
        // <icon iconName="arrow-down" className="text-primary" />
        <IoIosArrowRoundDown className="table-s-arr"/>
      );
    }
    return <IoIosArrowRoundUp className="table-s-arr"/>;
  };

  return (
    <div className={`bg-white ${className}`}>
      <div className="flex justify-between items-center mb-5">
        <div className="relative">
          <HiMiniMagnifyingGlass className="absolute left-4 top-2/4 -translate-y-2/4 table-search-icon" />
          <input
            type="text"
            placeholder={searchPlaceholder}
            value={searchValue}
            onChange={setSearchValue}
            className="pr-4 py-2 rounded-lg w-full table-search"
          />
        </div>
        <div>{additionalField}</div>
      </div>
      <div className="overflow-x-auto table-border">
        <table className="table-auto w-full">
          <thead className="st-head">
            <tr className="font-semibold st-head-tr">
              {columns.map((col, index) => (
                <th
                  key={index}
                  className={`p-4 text-left ${col.class} st-head-tr-th`}
                  style={{ width: col.width }}
                >
                  {col.sortable && col.field ? (
                    <div
                      className="cursor-pointer flex items-center"
                      onClick={() => handleSort(col.field)}
                    >
                      {col.name}
                      {getSortIcon(col.field)}
                    </div>
                  ) : (
                    col.name
                  )}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {data.map((row, rowIndex) => (
              <tr key={rowIndex}>
                {columns.map((col, colIndex) => (
                  <td key={colIndex} className="p-4 st-body-tr-td">
                    {/* {col.editButton && (
                      <button
                        onClick={() => col.editOnClick(row)}
                        className="bg-blue-500 text-white rounded p-1 mr-2"
                        title="Edit"
                      >
                        <icon iconName="pencil" />
                      </button>
                    )}
                    {col.deleteButton && (
                      <button
                        className="bg-red-500 text-white rounded p-1 mr-2"
                        title="Delete"
                        onClick={() => col.deleteOnClick(row)}
                      >
                        <icon iconName="trash" />
                      </button>
                    )} */}
                    {col.cell(row, rowIndex, baseIndex)}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
        {data.length === 0 && (
          <div className="text-center py-[5%] table-no-record">
            No records found
          </div>
        )}
      </div>
      <div className="flex sm:flex-row flex-col justify-between sm:items-center gap-5 p-5 border-t">
        <div className="flex items-center">
          <label htmlFor="rowsPerPage" className="mr-2 table-text">
            Rows per page:
          </label>
          <select
            id="rowsPerPage"
            value={limit}
            onChange={handleLimitChange}
            className="rounded-lg p-2 table-text table-text-border"
          >
            {isAllowAllList && <option value={""}>All</option>}
            <option value={5}>5</option>
            <option value={10}>10</option>
            <option value={25}>25</option>
            <option value={50}>50</option>
            <option value={100}>100</option>
          </select>
          <span className="ml-4 table-text">
            Number of records: {totalRecords}
          </span>
        </div>
        <div className="flex items-center gap-2 table-text">
          <button
            className="py-2 px-5 rounded table-arr "
            onClick={() => setOffset(0)}
            disabled={currentPage === 1}
          >
            &laquo;
          </button>
          <button
            className="py-2 px-5 rounded table-arr "
            onClick={() => setOffset(offset - limit)}
            disabled={currentPage === 1}
          >
            &lsaquo;
          </button>
          <span className="mx-4">
            Page {currentPage} of {totalPages || 1}
          </span>
          <button
            className="py-2 px-5 rounded table-arr "
            onClick={() => setOffset(offset + limit)}
            disabled={currentPage === (data.length === 0 ? 1 : totalPages)}
          >
            &rsaquo;
          </button>
          <button
            className="py-2 px-5 rounded table-arr"
            onClick={() => setOffset((totalPages - 1) * limit)}
            disabled={currentPage === (data.length === 0 ? 1 : totalPages)}
          >
            &raquo;
          </button>
        </div>
      </div>
    </div>
  );
};

export { Table1 };
